import React from "react";
import CrudPage from "./CrudPage";

const TYPES = ["informational", "navigational", "transactional", "commercial"];

export default function SearchIntent() {
  return (
    <CrudPage
      title="Search Intent"
      subtitle="Intent classifications (SEO Studio §6)."
      testIdPrefix="intent"
      listUrl="/seo/intents?limit=200"
      createUrl="/seo/intents"
      updateUrl={(id) => `/seo/intents/${id}`}
      deactivateUrl={(id, r) => `/seo/intents/${id}/deactivate?change_reason=${encodeURIComponent(r)}`}
      columns={[
        { key: "subject", label: "Subject" },
        { key: "intent_type", label: "Type" },
        { key: "confidence", label: "Confidence" },
      ]}
      fields={[
        { key: "subject", label: "Subject (keyword or topic)", type: "text" },
        { key: "intent_type", label: "Intent type", type: "select", options: TYPES },
        { key: "confidence", label: "Confidence (0–1)", type: "number" },
        { key: "signals", label: "Signals (comma-separated)", type: "text" },
        { key: "notes", label: "Notes", type: "textarea", rows: 3 },
      ]}
      emptyForm={{ subject: "", intent_type: "informational", confidence: "0.9",
                    signals: "", notes: "" }}
      fromRow={(row) => ({
        subject: row.data.subject || "",
        intent_type: row.data.intent_type,
        confidence: row.data.confidence ?? 0.9,
        signals: (row.data.signals || []).join(", "),
        notes: row.data.notes || "",
      })}
      canonicalizeCreate={(f) => ({
        subject: f.subject, intent_type: f.intent_type,
        confidence: Number(f.confidence),
        signals: (f.signals || "").split(",").map((x) => x.trim()).filter(Boolean),
        notes: f.notes || null,
      })}
      canonicalizeUpdate={(f) => ({
        intent_type: f.intent_type,
        confidence: Number(f.confidence),
        signals: (f.signals || "").split(",").map((x) => x.trim()).filter(Boolean),
        notes: f.notes || null,
        change_reason: "edited via admin UI",
      })}
    />
  );
}
